import type { textWidget } from "@/elements/text/text";
import type { TextWidgetV2 } from "@/elements/text/textV2";

export type FrameStateFull = {
    UID: string;
    parentUID?: string;
    entityType: "frameWidget";
    startX: number;
    startY: number;
    width: number;
    height: number;
    color: string;
    isHidden: boolean;
    aspectRatio: AspectRatioEnum;
    textName: ReturnType<textWidget["getState"]> | ReturnType<TextWidgetV2["getState"]>;
    presentationUID: string | null;
};
export type FrameStateMove = Pick<FrameStateFull, "startX" | "startY">;
export type FrameStateResize = Pick<
    FrameStateFull,
    "startX" | "startY" | "width" | "height" | "aspectRatio"
>;
export type FrameStateColor = Pick<FrameStateFull, "color">;
export type FrameStateHide = Pick<FrameStateFull, "isHidden">;
export type PresentationFrame = Pick<FrameStateFull, "presentationUID">;

export interface FrameStateMap {
    full: FrameStateFull;
    move: FrameStateMove;
    resize: FrameStateResize;
    color: FrameStateColor;
    hide: FrameStateHide;
    aspectRatio: AspectRatioEnum;
    presentationFrame: PresentationFrame;
}
export type FrameStateFixType = keyof FrameStateMap;

export enum AspectRatioEnum {
    R16_9 = "16:9",
    R4_3 = "4:3",
    R1_1 = "1:1",
    A4 = "A4",
    CUSTOM = "custom",
}
